import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectChecklistTableComponent } from './project-checklist-table.component';

@NgModule({
  declarations: [
    ProjectChecklistTableComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    ProjectChecklistTableComponent
  ]
})
export class ProjectChecklistTableModule { }
